import { render } from "./Clientes.vue?vue&type=template&id=6c5b9761&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=ts"
export * from "./Clientes.vue?vue&type=script&lang=ts"

import "./Clientes.vue?vue&type=style&index=0&id=6c5b9761&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6c5b9761"

export default script